
import Vue from 'vue'
import { mapGetters } from 'vuex'
import ChannelVideoTag from './ChannelVideoTag.vue'
import ChannelVideoSearchField from './ChannelVideoSearchField.vue'
import { VideosFiltersType, ChannelTagWithId } from '../utils/types'

export default Vue.extend({
  name: 'ChannelSidepanel',
  props: {
    value: {
      type: Object as () => VideosFiltersType,
      required: true,
    },
    showSearch: {
      type: Boolean,
      required: true,
    },
    showTagNavigation: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      search: this.$props.value?.search ?? '',
    }
  },
  computed: {
    ...mapGetters(['channelTags']),
    notSelectedTags(): ChannelTagWithId[] {
      return this.channelTags.filter(
        ({ id }: ChannelTagWithId) => this.value.tag !== id,
      )
    },
  },
  watch: {
    search(search) {
      this.$emit('input', { search })
    },
  },
  methods: {
    selectTag(tagId: string) {
      this.$emit('input', {
        tag: tagId,
      })
    },
  },

  components: {
    ChannelVideoTag,
    ChannelVideoSearchField,
  },
})
